import { BaseService } from "../../../Base/BaseService";

export const MasterLeadStatuses = {
  Created: "created",
  Contacted: "contacted",
  Converted: "converted",
  Cancelled: "rejected",
} as const;

export type MasterLeadStatus = (typeof MasterLeadStatuses)[keyof typeof MasterLeadStatuses];

export type AdminMasterLeadFilter = "" | MasterLeadStatus;

export interface IAdminMasterLead {
  id: number;

  name: string;
  contact: string;

  source: string;
  status: string;

  createdAt: string;
  updatedAt: string;
}

export interface IAdminMasterLeadsResponse {
  items: IAdminMasterLead[];

  total: number;
  limit: number;
  offset: number;
}

export interface IChangeMasterLeadStatusResponse {
  success: boolean;
  id: number;
  status: string;
  updatedAt: string;
}

export class AdminMasterLeadsService extends BaseService {
  public static async GetList(limit = 20, offset = 0, status: AdminMasterLeadFilter = ""): Promise<IAdminMasterLeadsResponse> {
    const params = new URLSearchParams();

    params.set("limit", String(limit));
    params.set("offset", String(offset));

    if (status) {
      params.set("status", status);
    }

    return await BaseService.get<IAdminMasterLeadsResponse>(this.BaseApiUrl + `/admin/master-leads?${params.toString()}`);
  }

  public static async ChangeStatus(id: number, status: MasterLeadStatus): Promise<IChangeMasterLeadStatusResponse> {
    return await BaseService.post<IChangeMasterLeadStatusResponse>(this.BaseApiUrl + `/admin/master-leads/${id}/status`, {
      status,
    });
  }
}
